module.exports = __webpack_public_path__ + "img/panel7.823d8a88.jpg";